import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root',
})
export class AddProgramareService {
    private basePath = environment.interop.basePath;

    // Endpoints for nomenclatoare (operator form)
    private moduleListUrl = this.basePath + 'api/programari/form/module/list';
    private locatiiByModulUrl = this.basePath + 'api/programari/form/module-locations/list/';
    private serviciiByModulLocatieUrl = this.basePath + 'api/programari/form/module-locations-services/list/';
    private tipuriProblemaByServiciuUrl = this.basePath + 'api/programari/form/services-problem-types/list/';
    private tipuriProgramByConfigUrl = this.basePath + 'api/programari/form/find-program-type-by-configuration/';
    private zileLibereUrl = this.basePath + 'api/programari/form/zile-libere/list';
    private getFullDaysUrl = this.basePath + 'api/programari/form/get-full-days/';
    private getAvailableSlotsUrl = this.basePath + 'api/programari/form/get-available-slots';
    private makeAppointmentUrl = this.basePath + 'api/programari/form/make-appointment';
    private resetAppointmentUrl = this.basePath + 'api/programari/form/reset-appointment';

    // Endpoint for store (operator)
    private storeOperatorUrl = this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.cerere.store;

    constructor(private http: HttpClient) { }

    // ========== NOMENCLATOARE METHODS ==========

    getModuleList() {
        return this.http.get<any>(this.moduleListUrl);
    }

    getLocatiiByModul(idModul: number) {
        return this.http.get<any>(this.locatiiByModulUrl + idModul);
    }

    getServiciiByModulLocatie(idModul: number, idLocatie: number) {
        return this.http.get<any>(this.serviciiByModulLocatieUrl + idModul + '/' + idLocatie);
    }

    getTipuriProblemaByServiciu(idServiciu: number) {
        return this.http.get<any>(this.tipuriProblemaByServiciuUrl + idServiciu);
    }

    getTipuriProgramByConfig(idModul: number, idLocatie: number, idServiciu: number) {
        return this.http.get<any>(this.tipuriProgramByConfigUrl + idModul + '/' + idLocatie + '/' + idServiciu);
    }

    getZileLibere() {
        return this.http.get<any>(this.zileLibereUrl);
    }

    getFullDays(idModul: number, idLocatie: number, idServiciu: number, idProgramType: number) {
        return this.http.get<any>(this.getFullDaysUrl + idModul + '/' + idLocatie + '/' + idServiciu + '/' + idProgramType);
    }

    // ========== SLOT METHODS ==========

    getAvailableSlots(payload: {
        id_modul: number;
        id_locatie: number;
        id_serviciu: number;
        id_program_type: number;
        date: string;
    }) {
        return this.http.post<any>(this.getAvailableSlotsUrl, payload);
    }

    makeAppointment(payload: {
        id_modul: number;
        id_locatie: number;
        id_serviciu: number;
        id_program_type: number;
        date: string;
        time: string;
    }) {
        return this.http.post<any>(this.makeAppointmentUrl, payload);
    }

    resetAppointment(payload: { appointmentIds: number[] }) {
        return this.http.post<any>(this.resetAppointmentUrl, payload);
    }

    // ========== STORE OPERATOR METHOD ==========

    storeProgramareOperator(payload: {
        id_modul: number;
        id_locatie: number;
        id_serviciu: number;
        id_problem_type: number;
        id_program_type: number;
        appointmentIds: number[];
        data: {
            name: string;
            cnp: string;
            phone: string;
            email: string;
            observatii: string;
        };
        phone: {
            dialCode: string;
            internationalNumber: string;
            isoCode: string;
            nationalNumber: string;
        };
        send_sms: boolean;
        send_email: boolean;
    }) {
        return this.http.post<any>(this.storeOperatorUrl, payload);
    }
}
